import { LOAD_STATE } from '@shared/axios';
import { buildGetAppCatalogConfig } from './app-catalog.api';
import { createReducer, INITIAL_STATE } from '../../../shared/redux';

const GET_APP_CATALOG_REQUEST_CALLED = '@integrations/app-catalog/GET_APP_CATALOG_REQUEST_CALLED';
const GET_APP_CATALOG_REQUEST_SUCCEEDED = '@integrations/app-catalog/GET_APP_CATALOG_REQUEST_SUCCEEDED';
const GET_APP_CATALOG_REQUEST_FAILED = '@integrations/app-catalog/GET_APP_CATALOG_REQUEST_FAILED';
const GET_APP_CATALOG_REQUEST_CANCELED = '@integrations/app-catalog/GET_APP_CATALOG_REQUEST_CANCELED';

export const getIntegrationAppsData = state => state.appCatalog.data;
export const getIntegrationAppsLoading = state => state.appCatalog.loadState;

export const getAppCatalog = () => ({
    type: GET_APP_CATALOG_REQUEST_CALLED,
    actionTypes: {
        success: GET_APP_CATALOG_REQUEST_SUCCEEDED,
        fail: GET_APP_CATALOG_REQUEST_FAILED,
        canceled: GET_APP_CATALOG_REQUEST_CANCELED,
    },
    config: buildGetAppCatalogConfig(),
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: {},
    error: null,
};

export const appCatalogReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_APP_CATALOG_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [GET_APP_CATALOG_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
    }),
    [GET_APP_CATALOG_REQUEST_FAILED]: (state, action) => ({
        ...state,
        error: action.payload,
        loadState: LOAD_STATE.FAIL,
        data: {},
    }),
});
